import type { ProcurementSupplierRow } from './types'

function timeClass(h: number | null): string {
  if (h === null) return 'text-gray-400'
  if (h <= 8) return 'text-emerald-700 font-medium'
  if (h <= 24) return 'text-gray-700'
  return 'text-red-600 font-medium'
}

export function SuppliersTable({
  suppliers,
  onRowClick,
}: {
  suppliers: ProcurementSupplierRow[]
  onRowClick?: (name: string) => void
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full">
      <div className="text-sm text-gray-500 mb-3">Мои поставщики</div>

      {suppliers.length === 0 ? (
        <p className="text-sm text-gray-400 py-4">Нет данных за период</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-xs text-gray-500">
                <th className="text-left font-normal pb-2">Поставщик</th>
                <th className="text-right font-normal pb-2">Запр.</th>
                <th className="text-right font-normal pb-2">Отв.</th>
                <th className="text-right font-normal pb-2">%</th>
                <th className="text-right font-normal pb-2">Ср. время</th>
              </tr>
            </thead>
            <tbody>
              {suppliers.map((s) => (
                <tr
                  key={s.name}
                  onClick={() => onRowClick?.(s.name)}
                  className={`border-t border-gray-100 ${
                    s.isBadResponder ? 'bg-red-50/40' : ''
                  } ${onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''}`}
                >
                  <td className="py-2 text-gray-900 truncate max-w-[180px]">{s.name}</td>
                  <td className="py-2 text-right tabular-nums">{s.requestsCount}</td>
                  <td className="py-2 text-right tabular-nums">{s.answersCount}</td>
                  <td className="py-2 text-right tabular-nums text-gray-600">{s.responseRate}%</td>
                  <td className={`py-2 text-right tabular-nums ${timeClass(s.avgResponseHours)}`}>
                    {s.avgResponseHours === null ? '—' : `${s.avgResponseHours}ч`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
